import { render, staticRenderFns } from "./DonutChart312.vue?vue&type=template&id=b0e3888e&scoped=true"
import script from "./DonutChart312.vue?vue&type=script&lang=js"
export * from "./DonutChart312.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e3888e",
  null
  
)

export default component.exports